import React from "react";
import Navbar from "../../components/Navbar_inicio";
import { MDBCol } from "mdbreact";
import FAQ from "./FAQ";
import FooterPage from "../../components/Footer";

class InicioFAQ extends React.Component {
  render() {
    return (
      <div>
        <MDBCol style={{ padding: "0px" }}>
          <Navbar />
          <FAQ />
          <FooterPage />
        </MDBCol>
      </div>
    );
  }
}

export default InicioFAQ;
